<section class="filter-logos-container">
  @for (logo of filterLogos; track logo) {
    <img [src]="logo.path" [alt]="logo.alt"/>
  }
</section>
